import { useNavigate } from 'react-router-dom';

import CircularCross from '../../assets/circular-cross.png';
import Styles from './Cancel.module.css';

const Cancel = () => {
  const navigate = useNavigate();

  return (
    <div className={Styles.pageContainer}>
      <img src={CircularCross} alt={'Circular check'} />
      <h1>Order Canceled</h1>
      <h2>Your purchase didn't go through</h2>
      <h3>Feel free to continue your purchase anytime.</h3>
      <button onClick={() => navigate('/flashcards')}>Back to Dashboard</button>
    </div>
  );
};

export default Cancel;
